<template>
  <div id="app" >
    <div v-if="ifLoad">
      <!-- <kw_gis_show></kw_gis_show> -->
      <router-view ref="router_main" class="col_dow"/>
      
      <!-- 联系客服组件 -->
      <customer_service v-if="customerInfo.showCustomerService" :customerInfo="customerInfo"></customer_service>
      <!-- 分享图片 画布生成功能 -->
      <kw_image_canvas v-if="imageCanvasInfo.ifLoad" :imageCanvasInfo="imageCanvasInfo" :dataInfo="imageCanvasInfo.dataInfo" :buttonSet="imageCanvasInfo.buttonSet" @onClose="hideCanvas"></kw_image_canvas>

      <!-- 底部弹窗分享按钮组 -->
      <kw_bottom_window v-if="(shareButtonInfo.ifLoad)" :shareButtonInfo="shareButtonInfo" @hideBottom="hideBottom"></kw_bottom_window>

      <el-dialog class="zdy_dialog" v-if="dialogInfo.ifLoad" :visible.sync="dialogInfo.ifLoad" width="100%" top="1vh" center append-to-body v-dialogDrag>
        <template slot="title"> 
            <div>
              {{(dialogInfo.pageInfo&&dialogInfo.pageInfo.menuName)?dialogInfo.pageInfo.menuName:'弹出层'}}
            </div>    
        </template>
        <kw_list v-if="dialogInfo.type==1" ref="kw_list_dialog" :initPageObj="dialogInfo.pageInfo" :ifDialog="1"></kw_list>
        <kw_look v-else-if="dialogInfo.type==11" ref="kw_look_dialog" :pageInfo="dialogInfo.pageInfo" :ifDialog="1"></kw_look>
        <iframe v-else-if="dialogInfo.type==999" ref="dialog999" :style="'width:100%;height:' + (windowHeight-70) + 'px;'" frameborder=0 name="showHere" scrolling=auto  :src="dialogInfo.url" ></iframe>
        <span slot="footer" v-if="dialogInfo.type==999">
          <el-button @click="dialogIframeZdyCancel">取 消</el-button>
          <el-button type="primary" @click="dialogIframeZdyConfirm">确 定</el-button>
        </span>
      </el-dialog>
      <!--注册组件-->
      <el-dialog class="zdy_dialog" v-if="logonCheck" :visible.sync="logonCheck" :show-close="false" fullscreen width="100%" top="0vh" center append-to-body v-dialogDrag>
        <LogonPage :ifChild="1" @closeMaskOrLogin="closeMaskOrLogin" @closeLoginDialog="closeLoginDialog"></LogonPage>
      </el-dialog>
      <el-dialog class="zdy_dialog" v-if="loginCheck" :visible.sync="loginCheck" :show-close="false" fullscreen width="100%" top="0vh" center append-to-body v-dialogDrag>
        <LoginPage :ifChild="1" @closeMaskOrLogin="closeMaskOrLogin" @closeLoginDialog="closeLoginDialog"></LoginPage>
      </el-dialog>

      <!-- 音频播放组件 -->
      <kw_back_audio v-if="backGroundAudioInfo.ifLoad" style="position:fixed;right:20px;top:100px;z-index:9999999999;" v-model="backGroundAudioInfo"></kw_back_audio>
    </div>
    <div v-else>
      <!--  -->
      数据加载中,请稍后
    </div>
  </div> 
</template>

<script>
  import 'element-ui/lib/theme-chalk/display.css';
  import pageUtils from '@/js/page/pageUtil.js';
  import utils from '@/js/utils/util.js';
  // 联系客服组件
  import customer_service from '@/components/kw/customer_service.vue';
  // 底部弹窗分享组件
  import kw_bottom_window from '@/components/kw/kw_bottom_window.vue';
  // 分享生成海报组件
  import kw_image_canvas from '@/components/kw/kw_image_canvas.vue';
  // 背景音频组件
  import kw_back_audio from '@/components/form/kw_back_audio.vue';
  // 表格块列表
  import kw_gis_show from '@/components/form/kw_gis_show.vue';
  // 登录组件
  import LoginPage from '@/pages/login/LoginPage.vue'
  
  export default {
    name: 'app',
    data(){
      return {
        // 访问来源 PC:2 或者 H5:3
        visitSource:utils.checkVisitSource(),
        landscape: [],
        data: {
          
        },
        // 登录页面的 打开状态
        loginCheck:false,
        loginPrevJson:{},
        loginNextJsFun:null,
        // 注册页面的 打开状态
        logonCheck:false,
        ifHead:true,
        openWay:null,
        /**
         * 联系客服功能
         */
        customerInfo:{
          // 是否显示
          showCustomerService:false,
          // 显示的微信号
          initContents:null,
          // 显示的微信二维码
          initCodeUrl:null
        },
        // 底部弹窗分享按钮组
        shareButtonInfo: {
          ifLoad: false
        },
        // 分享图片 画布生成功能
        imageCanvasInfo: {
          ifLoad: false
        },
        /**
         * 弹出层组件的信息
         */
        dialogInfo:{
          ifLoad:false
        },
        ifLoad:false,
        windowHeight:500,
        // 背景音频信息
        backGroundAudioInfo:{
          ifLoad:false,
          backGroundAudioPlayState:false,
          audioUrl:''
        }
      }
    },
    components: {
      customer_service,
      kw_bottom_window,
      kw_image_canvas,
      kw_back_audio,
      kw_gis_show,
      LoginPage,
      kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
      kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
    },
    watch:{
      '$route' (to, from) {
        var that = this;
        var queryOptions = that.$route.query;
        if(queryOptions.shamOpenId && queryOptions.shamOpenId != "") {
          console.log("路由加载完毕==queryOptions===============================",queryOptions);
          console.log("路由加载完毕==getHomeMenuList===============================",pageUtils.getHomeMenuList());
          console.log("路由加载完毕==getCookie===========JSESSIONID====================",pageUtils.getCookie("JSESSIONID"));
          console.log("路由加载完毕==getShamOpenId===============================",pageUtils.getShamOpenId());
          // if(queryOptions.sessionId && queryOptions.sessionId != "") {
          //   pageUtils.setCookie("JSESSIONID",queryOptions.sessionId);
          //   pageUtils.setCookie("test",queryOptions.sessionId);
          // }
          // if(queryOptions.shamOpenId && queryOptions.shamOpenId != "") {
          //   pageUtils.setShamOpenId(queryOptions.shamOpenId);
          // }
          if(queryOptions.openId && queryOptions.openId != "") {
            localStorage.openId = queryOptions.openId;
          }
          if(queryOptions.unionId && queryOptions.unionId != "") {
            localStorage.unionId = queryOptions.unionId;
          }
          // if(queryOptions.homeBarArr && queryOptions.homeBarArr != "") {
          //   pageUtils.setHomeMenuList(queryOptions.homeBarArr);
          // }
          if(queryOptions.openId && queryOptions.openId != "") {
            utils.getShamLoginId(that,function(){
              if(queryOptions.openId && queryOptions.openId != "") {
                utils.toHtLoginIn("", "", that, function(){
                  console.log("自动登录完毕后====================");
                  that.ifLoad = true;
                }, { loginType: 99 });
              } else {
                that.ifLoad = true;
              }
            });
          }
          // if(queryOptions.loginResultJsonStr) {
          //   utils.loginSuccessAfter(JSON.parse(queryOptions.loginResultJsonStr), that);
          // }
        }
        if(queryOptions.noHead==1) {
          that.ifHead = false;
        }
        if(queryOptions.openWay==2) {
          that.openWay = 2;
        }
      }
    },
    created() {
      this.windowHeight = window.innerHeight-40;
    },
    mounted() {
      var that = this;
      if(localStorage.domain_name && localStorage.domain_name != "") {
        document.title = that.GLOBAL.loginProductName[localStorage.domain_name];
      } else {
        document.title = that.GLOBAL.defaultProductName;
      }
      var options = this.$route.params;
      var queryOptions = that.$route.query;
      if(queryOptions && queryOptions.noHead==1) {
        that.ifHead = false;
      }
      if(queryOptions && queryOptions.openWay==2) {
          that.openWay = 2;
        }
      var cientType = pageUtils.getCientType();
      //如果是小程序内打开 判断是否需要自动登录或者是否有 session
      //判断是否有session信息 如果有则放到cookie中 如果没有则无操作
      if(cientType == "wechat") {
        if(!options.pageId) {
          options = this.$route.query;
        }
        var code = options.code;
        var loHref = window.location.href;
        if(loHref.indexOf("code")>=0) {
          code = window.location.href.substring(loHref.indexOf("code=")+5,loHref.indexOf("&state"));
          console.log("code===============",code);
          if(code) {
            var shamOpenId = pageUtils.getShamOpenId();
            
            var openId = localStorage.openId;
            if((shamOpenId>0) && openId != null && openId != undefined) {
              that.ifLoad = true;
            } else {
              utils.getWxOpenId(that,code,null);
            }
          } else {
            var shamOpenId = pageUtils.getShamOpenId();
            var openId = localStorage.openId;
            if((shamOpenId>0) && openId != null && openId != undefined) {
              that.ifLoad = true;
            } else {
              utils.getShamLoginId(that,null);
            }
          }
        } else {
          var shamOpenId = pageUtils.getShamOpenId();
          var openId = localStorage.openId;
          if((shamOpenId>0) && openId != null && openId != undefined) {
            //判断是否是微信内打开 如果是微信内打开则跳转到获取code 调用获取openId的方法
            that.ifLoad = true;
          } else {
            utils.getWxCode(that);
          }
        }
      } else if(cientType == "miniprogram"){
        //等待 路由加载完毕获取信息后再进行页面显示
        setTimeout(function(){that.ifLoad = true;},1000);
      } else {
        var shamOpenId = pageUtils.getShamOpenId();
        var homeMenuList = pageUtils.getHomeMenuList();
        console.log("shamOpenId=========app===================",shamOpenId);
        if((shamOpenId>0) && homeMenuList != null && homeMenuList != "") {
          that.ifLoad = true;
        } else {
          // 获取PC电脑本次登录信息 用于单点登录或者页面设置信息的记录
          utils.getShamLoginId(that,null);
        }
      }
      // that.ifLoad = true;
    },
    methods:{
      //    后退
      goBack(){
        var that = this;
        sessionStorage.goBackState = "true";
        that.$router.back()
      },
      // 隐藏图片分享组件
      hideCanvas() {
        this.imageCanvasInfo.ifLoad = false;
      },
      // 隐藏图片分享组件
      hideBottom(flag) {
        var shareButtonInfo = this.shareButtonInfo;
//        console.log("flag=========3333333333============",flag);
        shareButtonInfo.ifLoad = flag;
//        console.log("this.shareButtonInfo=========3333333333============",shareButtonInfo.ifLoad);
        this.shareButtonInfo = shareButtonInfo;
      },
      openLogin(json,nextJs){
        var that = this;
        that.loginCheck = true;
        that.loginPrevJson = json;
        that.loginNextJsFun = nextJs;
      },
      // 切换登录和注册页面
      changLoginOrLogon(){
        var that = this;
        if(that.loginCheck) {
          that.loginCheck = false;
          that.logonCheck = true;
        } else {
          that.loginCheck = true;
          that.logonCheck = false;
        }
      },
      closeMaskOrLogin(){
        var that = this;
        // 继续进行登录前的 执行操作
        var loginPrevJson = that.loginPrevJson;
//        console.log("closeMaskOrLogin=============1111==========================",loginPrevJson);
        if(loginPrevJson) {
          utils.request(that,loginPrevJson);
        }
        if(that.loginNextJsFun) {
          that.loginNextJsFun();
        }
//        console.log("closeMaskOrLogin=============1111==========================",loginPrevJson);
        that.closeLoginDialog();
      },
      /**
       * 弹出层 登录和注册的 并且清空下一步的全局json
       */
      closeLoginDialog(){
        var that = this;
        that.loginCheck = false;
        that.logonCheck = false;
        that.loginPrevJson = null;
      }
    },
    
  }
</script>

<style>
.el-popover{
    max-height: 500px;
    overflow-y: scroll;
}
.el-form-item{margin-bottom: 0 !important;}
.el-form-item__content{font-size: 16px !important;}
  .el-message-box{width: 300px !important;}

div.el-tabs__header{margin: 0;}
/*div.el-tabs__header{margin: 0 0 15px 0;}*/
div.el-tabs__header div.el-tabs__nav-wrap{padding-bottom: 5px;}
div.el-tabs__nav-wrap:after{height: 0px;}


  /*!
 * 
 * ant-design-vue v1.3.14
 * 
 * Copyright 2017-present, ant-design-vue.
 * All rights reserved.
 *       
 */
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* stylelint-disable at-rule-no-unknown */
@font-face {
  font-family: 'Chinese Quote';
  src: local('PingFang SC'), local('SimSun');
  unicode-range: U+2018, U+2019, U+201c, U+201d;
}
html,
body {
  width: 100%;
  height: 100%;
}
input::-ms-clear,
input::-ms-reveal {
  display: none;
}
html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
@-ms-viewport {
  width: device-width;
}
article,
aside,
dialog,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}
body {
  margin: 0;
  font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
}
[tabindex='-1']:focus {
  outline: none !important;
}
hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}
p {
  margin-top: 0;
  margin-bottom: 1em;
}
abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
}
address {
  margin-bottom: 1em;
  font-style: normal;
  line-height: inherit;
}
input[type='text'],
input[type='password'],
input[type='number'],
textarea {
  -webkit-appearance: none;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1em;
}
ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}
dt {
  font-weight: 500;
}
dd {
  margin-bottom: 0.5em;
  margin-left: 0;
}
blockquote {
  margin: 0 0 1em;
}
dfn {
  font-style: italic;
}
b,
strong {
  font-weight: bolder;
}
small {
  font-size: 80%;
}
sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
a {
  color: #1890ff;
  background-color: transparent;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}
a:focus {
  text-decoration: underline;
  -webkit-text-decoration-skip: ink;
          text-decoration-skip-ink: auto;
}
a:hover {
  color: #40a9ff;
}
a:active {
  color: #096dd9;
}
a:active,
a:hover {
  outline: 0;
  text-decoration: none;
}
a[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  pointer-events: none;
}
pre,
code,
kbd,
samp {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
  font-size: 1em;
}
pre {
  margin-top: 0;
  margin-bottom: 1em;
  overflow: auto;
}
figure {
  margin: 0 0 1em;
}
img {
  vertical-align: middle;
  border-style: none;
}
svg:not(:root) {
  overflow: hidden;
}
a,
area,
button,
[role='button'],
input:not([type='range']),
label,
select,
summary,
textarea {
  touch-action: manipulation;
}
table {
  border-collapse: collapse;
}
caption {
  padding-top: 0.75em;
  padding-bottom: 0.3em;
  color: rgba(0, 0, 0, 0.45);
  text-align: left;
  caption-side: bottom;
}
th {
  text-align: inherit;
}
input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}
button,
input {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}
button::-moz-focus-inner,
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
input[type='radio'],
input[type='checkbox'] {
  box-sizing: border-box;
  padding: 0;
}
input[type='date'],
input[type='time'],
input[type='datetime-local'],
input[type='month'] {
  -webkit-appearance: listbox;
}
textarea {
  overflow: auto;
  resize: vertical;
}
fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5em;
  font-size: 1.5em;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}
progress {
  vertical-align: baseline;
}
[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
  height: auto;
}
[type='search'] {
  outline-offset: -2px;
  -webkit-appearance: none;
}
[type='search']::-webkit-search-cancel-button,
[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}
output {
  display: inline-block;
}
summary {
  display: list-item;
}
template {
  display: none;
}
[hidden] {
  display: none !important;
}
mark {
  padding: 0.2em;
  background-color: #feffe6;
}
::-moz-selection {
  background: #1890ff;
  color: #fff;
}
::selection {
  background: #1890ff;
  color: #fff;
}

.zdy_dialog .el-dialog__header{
  /* padding: 5px 10px; */
  padding: 0;
  color: #fff;
  background: #6b7a99;
}
.zdy_dialog .el-dialog__headerbtn{
  top: 0px;
}
.zdy_dialog .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
}

.zdy_dialog .pageContentStyleSet{
  overflow: auto;
  padding: 0 10px 0 0;
}
.zdy_dialog .el-dialog{
  margin: 0 auto 0px;
}
</style>
